import { DiningOptionController } from '../controllers/dining_option.controller';
export const DiningOptionDefaultComponent = {
    template: `
        <p class="text-left">Please select your order type</p>
        <form class="radio-group">
            <input
                class="ordertype"
                id="pickup-{{::$id}}"
                name="order-{{::$id}}"
                ng-checked="$ctrl.cartDisplay.diningOption === 'TAKE_OUT' && $ctrl.cartDisplay.enablePickup"
                ng-if="$ctrl.cartDisplay.enablePickup"
                type="radio"
                value="pickup"
                />
                <label
                    class="PICKUP"
                    for="pickup-{{::$id}}"
                    id="landing-dining-option-pickup-input-label"
                    ng-click="$ctrl.makePickup()"
                    ng-if="$ctrl.cartDisplay.enablePickup">
                    Pickup
                </label>
             <input
                class="ordertype"
                id="delivery-{{::$id}}"
                name="order-{{::$id}}"
                ng-checked="$ctrl.cartDisplay.diningOption === 'DELIVERY' && $ctrl.cartDisplay.enableDelivery"
                ng-if="$ctrl.cartDisplay.enableDelivery"
                type="radio"
                value="delivery" />
                <label
                    class="DELIVERY"
                    for="delivery-{{::$id}}"
                    id="landing-dining-option-delivery-input-label"
                    ng-click="$ctrl.makeDelivery()"
                    ng-if="$ctrl.cartDisplay.enableDelivery">
                    Delivery
                </label>
        </form>
    `,
    controller: DiningOptionController
};
